import { createContext } from 'react';

export const GameSocketContext = createContext();

// [playerName, updatePlayerName]
export const GameSettingsContext = createContext(["", () => {}]);
